import React from "react";
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

/*
ADMIN PAGES
*/

import AdminLogin from "./pages/AdminLogin";
import AdminSignup from "./pages/AdminSignup";
import Dashboard from "./pages/Dashboard";
import CreateRestaurant from "./pages/CreateRestaurant";
import EditRestaurant from "./pages/EditRestaurant";
import OwnerList from "./pages/OwnerList";
import RestaurantDetails from "./pages/RestaurantDetails";

/*
OWNER PAGES
*/

import OwnerLogin from "./pages/OwnerLogin";

/*
OWNER LAYOUT PAGES
*/

import OwnerLayout from "./pages/owner/OwnerLayout";
import OwnerDashboardHome from "./pages/owner/OwnerDashboardHome.js";
import OwnerMenu from "./pages/owner/OwnerMenu.js";
import OwnerEditRestaurant from "./pages/owner/OwnerEditRestaurant";
import OwnerQRCode from "./pages/owner/OwnerQRCode";
import EditItem from "./pages/owner/EditItem";
import FoodItemDetails from "./pages/owner/FoodItemDetails";
import ImportMenu from "./pages/owner/ImportMenu";
import OwnerUpgrade from "./pages/owner/OwnerUpgrade.js";
import OwnerDashboard from "./pages/owner/OwnerDashboard.js";


/*
PROTECTED ROUTE
*/

import ProtectedRoute from "./pages/ProtectedRoute";

export default function App() {

  return (

    <Routes>

      {/* DEFAULT */}

      <Route
        path="/"
        element={
          <Navigate to="/owner-login" />
        }
      />

      {/* ================= ADMIN ================= */}

      <Route
        path="/admin-login"
        element={<AdminLogin />}
      />

      <Route
        path="/admin-signup"
        element={<AdminSignup />}
      />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute role="admin">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/edit-restaurant/:id"
        element={<EditRestaurant />}
      />



      <Route
        path="/owners"
        element={<OwnerList />}
      />

      <Route
        path="/create-restaurant"
        element={
          <ProtectedRoute role="admin">
            <CreateRestaurant />
          </ProtectedRoute>
        }
      />


<Route
  path="/restaurant/:id"
  element={<RestaurantDetails />}
/>

<Route path="/owner/dashboard/pro/:restaurantId" element={<OwnerDashboard />} />

      {/* ================= OWNER LOGIN ================= */}

      <Route
        path="/owner-login"
        element={<OwnerLogin />}
      />

      {/* ================= OWNER DASHBOARD WITH SIDEBAR ================= */}

      <Route
        path="/owner"
        element={
          <ProtectedRoute role="owner">
            <OwnerLayout />
          </ProtectedRoute>
        }
      >

        {/* Default owner page */}

        <Route
          index
          element={
            <Navigate to="dashboard" />
          }
        />

        <Route
          path="dashboard"
          element={<OwnerDashboardHome />}
        />

        <Route
          path="menu"
          element={<OwnerMenu />}
        />

        <Route
          path="edit"
          element={<OwnerEditRestaurant />}
        />

        <Route
          path="qr"
          element={<OwnerQRCode />}
        />

        <Route
          path="upgrade"
          element={<OwnerUpgrade />}
        />

      </Route>

        
        <Route
          path="/edit-item/:itemId"
          element={<EditItem />}
        />

        <Route
          path="/food-item/:itemId"
          element={<FoodItemDetails />}
        />

        <Route
          path="/owner/import-menu"
          element={<ImportMenu />}
        />
      {/* ================= 404 ================= */}

      <Route
        path="*"
        element={
          <h2>
            Page Not Found
          </h2>
        }
      />

    </Routes>

  );

}